import { StripeService } from './../../../services/stripe.service';
import { UserService } from './../../../services/user.service';
import { AuthService } from './../../../services/auth.service';
import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import {Router, ActivatedRoute, NavigationEnd, RoutesRecognized } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { Title } from '@angular/platform-browser';
import { Role } from 'src/app/models';
import * as jquery from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { filter, pairwise } from "rxjs/operators";

@Component({
  templateUrl: 'sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  signInForm: FormGroup;
  submitted = false;
  returnUrl: string;
  error = false;
  errorMsg = 'An error occurred when submitting form data.';
  showAccountActivation = false;
  showAccountSuspended = false;
  showActivationSuccess = false;
  modalText = 'Loading...';
  showVoucherExpired = false;
  showInvalidVoucher = false;
  showVoucherDeleted = false;
  previousUrl: string;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private authService: AuthService,
      private userService: UserService,
      private stripeService: StripeService,
      private pageTitleService: Title,
      private cookieService: CookieService
  ) {
  }

  ngOnInit() {

    // check if user is logged in
    if (this.cookieService.get('token')) {
      this.router.navigateByUrl('/user/dashboard');
    } else {
      this.authService.removeTokenAndUserDetails();
    }

    this.setFormControls();
    this.setPageTitle();
    this.setRedirectUrl();
  }

  // Convenience getter for easy access to form fields
  get f() { return this.signInForm.controls; }

  setRedirectUrl() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/user/dashboard';
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Sign In');
  }

  setFormControls() {
    this.signInForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8)
      ]),
      voucher: new FormControl('', [
        Validators.maxLength(10)
      ])
    });
  }

  onSubmit() {
    this.submitted = true;
    // Stop here if there's form errors
    if (this.signInForm.invalid) {
        return;
    }

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Signing in...';

    this.authService.login(this.f.email.value, this.f.password.value, this.f.voucher.value)
      .pipe(first())
      .subscribe(
        loginData => {
          if (!loginData.success) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);

            // Show for non activated users
            if (loginData.error?.code == 500) {

              //if (loginData.error?.msg == "User is not yet activated") {
              if (loginData.error?.msg.includes("Please verify your email")) {  
                this.showAccountActivation = true;
              }

              if (loginData.error?.msg == "User account is suspended") {
                this.showAccountSuspended = true;
              }

              // if (loginData.error?.msg == "Voucher is already expired") {
              //
              //   alert(999);
              //   //this.router.navigate(['/payment-method']);
              //   //this.router.navigateByUrl('/payment-method');
              //   this.router.navigateByUrl('/payment-method', {state: {email: this.f.email.value, from: 'sign-in'}});
              //
              //   //this.showVoucherExpired = true;
              // }

              // if (loginData.error?.msg == "Invalid voucher code") {
              //   this.showVoucherExpired = true;
              //   this.showInvalidVoucher = true;
              // }
              //
              // if (loginData.error?.msg == "Voucher maximum users reached") {
              //   this.showVoucherExpired = true;
              //   this.showInvalidVoucher = true;
              // }
              //
              // if (loginData.error?.msg == "Voucher is already expired") {
              //   this.showVoucherExpired = true;
              //   //this.showInvalidVoucher = true;
              // }
              //
              // if (loginData.error?.msg == "Invalid voucher code") {
              //   this.showVoucherExpired = true;
              //   this.showInvalidVoucher = true;
              // }
              //
              // if (loginData.error?.msg == "Deleted voucher code") {
              //   this.showVoucherExpired = true;
              // }

              setTimeout(() => {
                this.showAccountActivation = false;
                this.showAccountSuspended = false;
              }, 5000);

              return;
            }

            this.error = true;
            this.errorMsg = loginData.error.msg;

            // Hides the error message after 5 seconds
            setTimeout(() => {
              this.error = false;
            }, 5000);

            // Scroll the sidenav to top
            const container = document.getElementById('sign-in-sidenav');
            container.scrollTop = 0;

            return;
          }

          // check if user has a voucher and voucher has an error
          if (loginData.data.voucher.exist && loginData.data.voucher.error != "") {
            this.router.navigateByUrl('/payment-method', {state: {
                                    email: this.f.email.value, from: 'sign-in',
                                    voucherError: true }});
            return;
          }

          // Check Role if `Admin`
          if (loginData.data.user.role === Role.Admin) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);

            // Redirect to Dashboard
            this.router.navigate([this.returnUrl]);
            return;
          }

          // Check Role if `Individual`
          if (loginData.data.user.role === Role.Individual) {
            // Check if user has a delivery address
            this.userService.getDeliveryAddress()
            .pipe(first())
            .subscribe(
              addressData => {
                if (environment.includeDeviceDelivery) {
                  if (!addressData.success && addressData.error.code === 422) {

                    setTimeout(() => {
                      // hide progress modal
                      this.hideProgressModal();
                    }, 500);

                    this.router.navigateByUrl('/delivery-address', {state: {email: this.f.email.value}});
                    return;
                  }
                }

                // Check if user has a payment method
                this.stripeService.getPaymentMethod()
                  .pipe(first())
                  .subscribe(
                    paymentData => {
                      if (paymentData.success && paymentData.data.methods.length == 0 || !paymentData.user?.is_subscribed) {

                        setTimeout(() => {
                          // hide progress modal
                          this.hideProgressModal();
                        }, 500);

                        this.router.navigateByUrl('/payment-method', {state: {email: this.f.email.value, from: 'sign-in'}});
                      } else {
                        // Redirect to Dashboard

                        setTimeout(() => {
                          // hide progress modal
                          this.hideProgressModal();
                        }, 500);

                        this.router.navigate([this.returnUrl]);
                      }
                    }
                  );
              },
              error => { }
            );
          }

          // Check Role if `Employee` or `Manager`
          if (loginData.data.user.role === Role.Employee || loginData.data.user.role === Role.Manager) {

            // Check if organisation is suspended or not by checking the `is_subscribed` value
            if (!loginData.data.user?.is_subscribed) {

              setTimeout(() => {
                // hide progress modal
                this.hideProgressModal();
              }, 500);

              this.error = true;
              this.errorMsg = 'Your organisations has been disabled and your access to system is now suspended.';

              // Hides the error message after 5 seconds
              setTimeout(() => {
                this.error = false;
              }, 5000);

              // Scroll the sidenav to top
              const container = document.getElementById('sign-in-sidenav');
              container.scrollTop = 0;

              return;
            }

            // Redirect to Dashboard
            this.router.navigate([this.returnUrl]);
          }

        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;

          // Hides the error message after 3 seconds
          setTimeout(() => {
            this.error = false;
          }, 5000);
        });
  }

  resendActivationLink() {
    this.showAccountActivation = false;

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Sending activation link...';

    this.authService.resendActivationLink(this.f.email.value)
      .subscribe(
        data => {
          if (data.success) {

            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);

            this.showActivationSuccess = true;

            setTimeout(() => {
              this.showActivationSuccess = false;
            }, 5000);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  showPassword() {
    const passwordInputType = jquery('#password-input').attr('type');
    if (passwordInputType === 'password') {
      jquery('#password-input').attr('type', 'text');
      jquery('#show-password-icon').removeClass('fa-eye-slash');
      jquery('#show-password-icon').addClass('fa-eye');
    } else {
      jquery('#password-input').attr('type', 'password');
      jquery('#show-password-icon').addClass('fa-eye-slash');
      jquery('#show-password-icon').removeClass('fa-eye');
    }
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
